module.exports = __webpack_public_path__ + "static/supply_chain-8176e8e00967fe7658871f4bb6be4102.jpg";